import {UserContext} from 'providers/UserProvider'
import {useContext} from 'react'

const useUser = () => {
  return useContext(UserContext)
}

export default useUser
